import { LightColors } from "@thingsw/pitta-modules";
import React from "react";

interface SurveyProgressBarProps {
  currentStep: number;
  stepCount: number;
  className?: string;
}

const Stepper = ({
  currentStep,
  stepCount,
  className,
}: SurveyProgressBarProps) => {
  const array = Array.from({ length: stepCount }, (_, i) => i);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        gap: 4,
      }}
      className={className}
    >
      {array.map((_, i) => (
        <div
          key={i}
          style={{
            width: `100%`,
            height: 4,
            backgroundColor:
              currentStep === i
                ? LightColors.primary["7"]
                : LightColors.primary["6"],
          }}
        ></div>
      ))}
    </div>
  );
};

export default Stepper;
